
// import React, { useEffect, useId, useState } from "react";
// import mermaid from "mermaid";
// import "./MermaidDiagram.css";



// mermaid.initialize({
//   startOnLoad: false,
//   securityLevel: "strict",
//   theme: "default",
//   flowchart: {
//     useMaxWidth: true,
//     htmlLabels: false,
//     curve: "linear",
//     nodeSpacing: 40,
//     rankSpacing: 45,
//     diagramPadding: 16,
//   },
// });







// export default function MermaidDiagram({ chart }) {
//   const generatedId = useId().replace(/:/g, "");
//   const [svg, setSvg] = useState("");
//   const [error, setError] = useState(false);

//   function normalizeMermaidSource(chart) {
//   return chart
//     .replace(/&#x20;/gi, " ")
//     .replace(/&nbsp;/gi, " ")
//     .replace(/\\\r?\n/g, "\n")
//     .replace(/^\s*```(?:mermaid)?\s*/i, "")
//     .replace(/\s*```\s*$/i, "")
//     .trim();
// }

//   useEffect(() => {
//     let cancelled = false;

//     async function renderDiagram() {
//       console.count("Mermaid renderDiagram called");
//   console.log("Chart source:", chart);
//       setSvg("");
//       setError(false);

//       try {
//         const source = normalizeMermaidSource(chart);
//         console.log("Mermaid source:", source);
// console.log("Detected chart type:", source.split("\n")[0]);

// if (!/^(flowchart|graph)\s+(TD|TB|BT|RL|LR)\b/m.test(source)) {
//   throw new Error("Only Mermaid flowcharts are supported.");
// }

//         const result = await mermaid.render(
//           `mermaid-${generatedId}`,
//           source
//         );

//         if (!cancelled) setSvg(result.svg);
//       } catch(err) {
//         console.error("Mermaid render error:", err);
//         if (!cancelled) setError(true);
//       }
//     }

//     if (chart?.trim()) renderDiagram();

//     return () => {
//       cancelled = true;
//     };
//   }, [chart, generatedId]);

//   if (error) {
//     return (
//       <div className="mermaid-error">
//         Diagram could not be rendered.
//         <pre>{chart}</pre>
//       </div>
//     );
//   }

//   return (
//     <div className="mermaid-wrapper">
//       {svg && (
//         <div
//           className="mermaid-svg"
//           dangerouslySetInnerHTML={{ __html: svg }}
//         />
//       )}
//     </div>
//   );
// }

////////////working one/////////////

// import React, { useEffect, useId, useState, useRef } from "react";
// import mermaid from "mermaid";
// import "./MermaidDiagram.css";

// mermaid.initialize({
//   startOnLoad: false,
//   securityLevel: "loose",
//   theme: "default",
//   flowchart: {
//     useMaxWidth: true,
//     htmlLabels: true,
//     curve: "basis",
//     diagramPadding: 4, // 🛠️ Reduced from 16 to 4 to eliminate internal canvas padding
//     nodeSpacing: 30,
//     rankSpacing: 30,
//   },
// });

// export default function MermaidDiagram({ chart }) {
//   const rawId = useId();
//   const diagramId = `mermaid-${rawId.replace(/[^a-zA-Z0-9]/g, "")}`;
  
//   const [svg, setSvg] = useState("");
//   const [error, setError] = useState(false);
//   const [isFullscreen, setIsFullscreen] = useState(false);
//   const containerRef = useRef(null);

//   function normalizeMermaidSource(rawChart) {
//     let source = rawChart
//       .replace(/&#x20;/gi, " ")
//       .replace(/&nbsp;/gi, " ")
//       .replace(/\\\r?\n/g, "\n")
//       .replace(/^\s*```(?:mermaid)?\s*/i, "")
//       .replace(/\s*```\s*$/i, "")
//       .trim();

//     // 🛠️ Auto-fixer: Automatically wrap unquoted node text containing parentheses in double quotes
//     // Example: A[User (React)] becomes A["User (React)"]
//     source = source
//       .replace(/\b(participant|actor|style|subgraph|end|loop|alt|else)\b/g, "\n$1")
//       .replace(/\n\s*\n/g, "\n");
//     source = source.replace(/([A-Za-z0-9_-]+)\s*\[\s*([^"\]\n]*\([^\]\n]*\)[^\]\n]*)\s*\]/g, '$1["$2"]');
//     source = source.replace(/([A-Za-z0-9_-]+)\s*\(\s*([^")\n]*\([^)\n]*\)[^)\n]*)\s*\)/g, '$1("$2")');
//     source = source.replace(/([A-Za-z0-9_-]+)\s*\{\s*([^"}\n]*\([^}\n]*\)[^}\n]*)\s*\}/g, '$1{"$2"}');

//     return source.trim();
//   }

//   useEffect(() => {
//     let cancelled = false;

//     async function renderDiagram() {
//       setSvg("");
//       setError(false);

//       try {
//         const source = normalizeMermaidSource(chart);
//         if (!source) return;

//         const firstLine = source.split("\n")[0].trim().toLowerCase();
//         const supportedTypes = ["flowchart", "graph", "sequencediagram", "classdiagram", "stateDiagram".toLowerCase()];
//         const isSupported = supportedTypes.some(type => firstLine.startsWith(type));

//         if (!isSupported) {
//           throw new Error("Unsupported or invalid Mermaid diagram type.");
//         }

//         const result = await mermaid.render(diagramId, source);

//         if (!cancelled) {
//           setSvg(result.svg);
//         }
//       } catch (err) {
//         console.error("Mermaid render error:", err);
//         if (!cancelled) setError(true);
//       }
//     }

//     if (chart?.trim()) {
//       renderDiagram();
//     }

//     return () => {
//       cancelled = true;
//     };
//   }, [chart, diagramId]);

//   const handleCopyCode = () => {
//     navigator.clipboard.writeText(normalizeMermaidSource(chart));
//     alert("Mermaid code copied to clipboard!");
//   };

//   if (error) {
//     return (
//       <div className="mermaid-error">
//         <p>⚠️ Diagram could not be rendered due to syntax issues.</p>
//         <pre>{chart}</pre>
//       </div>
//     );
//   }

//   return (
//     <div className={`mermaid-wrapper ${isFullscreen ? "fullscreen" : ""}`} ref={containerRef}>
//       <div className="mermaid-toolbar">
//         <span className="mermaid-badge">Diagram</span>
//         <div className="mermaid-actions">
//           <button onClick={handleCopyCode} title="Copy Mermaid Code">
//             📋 Copy Code
//           </button>
//           <button onClick={() => setIsFullscreen(!isFullscreen)} title="Toggle Fullscreen">
//             {isFullscreen ? "🗗 Exit Fullscreen" : "⛶ Fullscreen"}
//           </button>
//         </div>
//       </div>

//       <div className="mermaid-svg-container">
//         {svg ? (
//           <div
//             className="mermaid-svg"
//             dangerouslySetInnerHTML={{ __html: svg }}
//           />
//         ) : (
//           <div className="mermaid-loading">Rendering diagram...</div>
//         )}
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useId, useRef, useState, useCallback } from "react";
import mermaid from "mermaid";
import "./MermaidDiagram.css";

// "strict" is important: the diagram source comes from an LLM.
// Interactivity below uses our own DOM listeners, so "loose" is not needed.

mermaid.initialize({
  startOnLoad: false,
  securityLevel: "strict",
  theme: "base",

  themeVariables: {
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: "18px",
    lineColor: "#64748b",
    textColor: "#172033",
    mainBkg: "#eff6ff",
    primaryColor: "#dbeafe",
    primaryTextColor: "#1e3a8a",
    primaryBorderColor: "#60a5fa",
    secondaryColor: "#dcfce7",
    secondaryTextColor: "#166534",
    secondaryBorderColor: "#4ade80",
    tertiaryColor: "#f3e8ff",
    tertiaryTextColor: "#6b21a8",
    tertiaryBorderColor: "#c084fc",
    clusterBkg: "#f8fafc",
    clusterBorder: "#cbd5e1",
    edgeLabelBackground: "#ffffff",
    titleColor: "#111827",
    nodeBorder: "#60a5fa",
    actorBkg: "#dbeafe",
    actorBorder: "#60a5fa",
    actorTextColor: "#1e3a8a",
    signalColor: "#64748b",
    signalTextColor: "#172033",
    labelBoxBkgColor: "#f8fafc",
    labelBoxBorderColor: "#cbd5e1",
    labelTextColor: "#172033",
    sectionBkgColor: "#dbeafe",
    altSectionBkgColor: "#f3e8ff",
    taskBkgColor: "#bfdbfe",
    taskBorderColor: "#3b82f6",
    taskTextColor: "#172033",
    activeTaskBkgColor: "#bbf7d0",
    activeTaskBorderColor: "#22c55e",
  },

 flowchart: {
  useMaxWidth: true,
  htmlLabels: true,
  curve: "basis",
  diagramPadding: 20,
  nodeSpacing: 65,
  rankSpacing: 75,
  wrappingWidth: 220,
},

sequence: {
  useMaxWidth: true,
  actorMargin: 90,
  messageMargin: 55,
  diagramMarginX: 30,
  diagramMarginY: 25,
  actorFontSize: 20,
  messageFontSize: 18,
  noteFontSize: 18,
  width: 160,
  height: 60,
},

  gantt: {
    useMaxWidth: true,
    leftPadding: 120,
    rightPadding: 30,
    topPadding: 35,
    barHeight: 30,
    barGap: 12,
    fontSize: 16,
    sectionFontSize: 17,
    numberSectionStyles: 4,
  },
});


const MIN_ZOOM = 0.3;
const MAX_ZOOM = 6;
const clamp = (n, lo, hi) => Math.min(hi, Math.max(lo, n));

function normalizeMermaidSource(raw) {
  let source = (raw || "")
    .replace(/&#x20;/gi, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\\\r?\n/g, "\n")
    .replace(/^\s*```(?:mermaid)?\s*/i, "")
    .replace(/\s*```\s*$/i, "")
    .trim();

  // Flowcharts only: quote plain [labels] that contain parentheses,
  // e.g. A[User (React)] -> A["User (React)"].
  // Skips shapes such as [(db)], [[sub]], ["already quoted"], [/parallelogram/].
  if (/^\s*(flowchart|graph)\b/i.test(source)) {
    source = source.replace(
      /([A-Za-z0-9_-]+)\[\s*([^"\[\]\n(\/\\][^\[\]\n]*\([^\[\]\n]*\)[^\[\]\n]*)\]/g,
      '$1["$2"]'
    );
  }
  return source;
}

// Mermaid flowchart node elements have ids like "flowchart-A-0"
const getNodeId = (el) => /^flowchart-(.+)-\d+$/.exec(el.id || "")?.[1] ?? null;

export default function MermaidDiagram({
  chart,
  isStreaming = false,
  onAskAboutNode, // optional: (label: string) => void
}) {
  const diagramId = `mermaid-${useId().replace(/[^a-zA-Z0-9]/g, "")}`;

  const [svg, setSvg] = useState("");
  const [error, setError] = useState(null);
  const [view, setView] = useState({ x: 0, y: 0, k: 1 });
  const [selected, setSelected] = useState(null); // { id, label }
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [copied, setCopied] = useState(false);

  const viewportRef = useRef(null);
  const stageRef = useRef(null);
  const drag = useRef(null);

  /* ---------- render (waits for streaming to finish) ---------- */
  useEffect(() => {
    if (isStreaming) return;
    let cancelled = false;

    const timer = setTimeout(async () => {
      try {
        const source = normalizeMermaidSource(chart);
        if (!source) return;
        const result = await mermaid.render(diagramId, source);
        if (!cancelled) {
          setSvg(result.svg);
          setError(null);
          setSelected(null);
          setView({ x: 0, y: 0, k: 1 });
        }
      } catch (err) {
        // Mermaid leaves a broken helper element in <body> on failure
        document.getElementById("d" + diagramId)?.remove();
        if (!cancelled) setError(err?.message || "Syntax error");
      }
    }, 150);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [chart, diagramId, isStreaming]);

  /* ---------- highlight selected node + connected edges/nodes ---------- */
  useEffect(() => {
    const svgEl = stageRef.current?.querySelector("svg");
    if (!svgEl) return;

    svgEl.classList.toggle("has-selection", !!selected);
    svgEl
      .querySelectorAll(".is-selected, .is-connected")
      .forEach((el) => el.classList.remove("is-selected", "is-connected"));
    if (!selected) return;

    const nodes = svgEl.querySelectorAll(".node");
    const id = selected.id;

    nodes.forEach((n) => {
      if (getNodeId(n) === id) n.classList.add("is-selected");
    });

    // Edges carry classes LS-<fromId> and LE-<toId>
    const edges = svgEl.querySelectorAll(
      `.LS-${CSS.escape(id)}, .LE-${CSS.escape(id)}`
    );
    const neighbourIds = new Set();
    edges.forEach((edge) => {
      edge.classList.add("is-connected");
      edge.classList.forEach((c) => {
        if (c.startsWith("LS-") || c.startsWith("LE-")) {
          const other = c.slice(3);
          if (other !== id) neighbourIds.add(other);
        }
      });
    });
    nodes.forEach((n) => {
      if (neighbourIds.has(getNodeId(n))) n.classList.add("is-connected");
    });
  }, [selected, svg]);

  /* ---------- zoom ---------- */
  const zoomBy = useCallback((factor, cx, cy) => {
    setView((v) => {
      const k = clamp(v.k * factor, MIN_ZOOM, MAX_ZOOM);
      const r = k / v.k;
      return { k, x: cx - (cx - v.x) * r, y: cy - (cy - v.y) * r };
    });
  }, []);

  const zoomFromCenter = (factor) => {
    const rect = viewportRef.current?.getBoundingClientRect();
    if (rect) zoomBy(factor, rect.width / 2, rect.height / 2);
  };

  // Wheel zoom needs a non-passive listener so we can preventDefault.
  // Without Ctrl/Cmd the page scrolls normally (except in fullscreen).
  useEffect(() => {
    const vp = viewportRef.current;
    if (!vp) return;
    const onWheel = (e) => {
      if (!e.ctrlKey && !e.metaKey && !isFullscreen) return;
      e.preventDefault();
      const rect = vp.getBoundingClientRect();
      zoomBy(
        e.deltaY < 0 ? 1.1 : 0.9,
        e.clientX - rect.left,
        e.clientY - rect.top
      );
    };
    vp.addEventListener("wheel", onWheel, { passive: false });
    return () => vp.removeEventListener("wheel", onWheel);
  }, [zoomBy, isFullscreen, svg]);

  /* ---------- pan (drag) ---------- */
  const onPointerDown = (e) => {
    if (e.button !== 0) return;
    drag.current = {
      sx: e.clientX,
      sy: e.clientY,
      ox: view.x,
      oy: view.y,
      moved: false,
    };
    const move = (ev) => {
      const d = drag.current;
      if (!d) return;
      const dx = ev.clientX - d.sx;
      const dy = ev.clientY - d.sy;
      if (Math.abs(dx) + Math.abs(dy) > 4) d.moved = true;
      if (d.moved) setView((v) => ({ ...v, x: d.ox + dx, y: d.oy + dy }));
    };
    const up = () => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
      // let the click event read drag.moved first
      setTimeout(() => (drag.current = null), 0);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  };

  /* ---------- click a node ---------- */
  const onStageClick = (e) => {
    if (drag.current?.moved) return; // it was a drag, not a click
    const nodeEl = e.target.closest?.(".node");
    const id = nodeEl && getNodeId(nodeEl);
    if (!nodeEl || !id) {
      setSelected(null);
      return;
    }
    const label = nodeEl.textContent.trim();
    setSelected((s) => (s?.id === id ? null : { id, label }));
  };

  /* ---------- fullscreen: Esc to exit ---------- */
  useEffect(() => {
    if (!isFullscreen) return;
    const onKey = (e) => e.key === "Escape" && setIsFullscreen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isFullscreen]);

  /* ---------- toolbar actions ---------- */
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(normalizeMermaidSource(chart));
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      /* clipboard blocked - ignore */
    }
  };

  const handleDownload = () => {
    const blob = new Blob([svg], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "diagram.svg";
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleAsk = () => {
    if (!selected || !onAskAboutNode) return;
    onAskAboutNode(selected.label);
    setIsFullscreen(false);
  };

  /* ---------- states ---------- */
  if (isStreaming && !svg) {
    return (
      <div className="mermaid-wrapper">
        <div className="mermaid-loading">Generating diagram...</div>
      </div>
    );
  }

  if (error && !svg) {
    return (
      <div className="mermaid-error">
        <p>Diagram could not be rendered: {error}</p>
        <pre>{chart}</pre>
      </div>
    );
  }

  return (
    <div className={`mermaid-wrapper ${isFullscreen ? "fullscreen" : ""}`}>
      <div className="mermaid-toolbar">
        <span className="mermaid-badge">Diagram</span>
        <div className="mermaid-actions">
          <button onClick={() => zoomFromCenter(1.25)} title="Zoom in">+</button>
          <button onClick={() => zoomFromCenter(0.8)} title="Zoom out">−</button>
          <button
            onClick={() => setView({ x: 0, y: 0, k: 1 })}
            title="Reset view"
          >
            Reset
          </button>
          <button onClick={handleCopy}>{copied ? "Copied" : "Copy code"}</button>
          <button onClick={handleDownload} disabled={!svg}>Download SVG</button>
          <button onClick={() => setIsFullscreen((f) => !f)}>
            {isFullscreen ? "Exit" : "Fullscreen"}
          </button>
        </div>
      </div>

      <div
        className="mermaid-viewport"
        ref={viewportRef}
        onPointerDown={onPointerDown}
        onClick={onStageClick}
      >
        {svg ? (
          <div
            ref={stageRef}
            className="mermaid-stage"
            style={{
              transform: `translate(${view.x}px, ${view.y}px) scale(${view.k})`,
              marginTop:0,
              transformOrigin: "0 0",
              
            }}
            dangerouslySetInnerHTML={{ __html: svg }}
          />
        ) : (
          <div className="mermaid-loading">Rendering diagram...</div>
        )}
      </div>

      <div className="mermaid-hint">
        Drag to pan. Ctrl/⌘ + scroll to zoom. Click a node to highlight it.
      </div>

      {selected && (
        <div className="mermaid-selection">
          <span className="mermaid-selection-label">
            Selected: <strong>{selected.label}</strong>
          </span>
          <div className="mermaid-actions">
            {onAskAboutNode && (
              <button className="primary" onClick={handleAsk}>
                Ask about this
              </button>
            )}
            <button onClick={() => setSelected(null)}>Clear</button>
          </div>
        </div>
      )}
    </div>
  );
}
